//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ServerAction from "../ServerAction.js";

const SetScreenPropertiesAction = class SetScreenPropertiesAction extends ServerAction {
  constructor(sessionId) {
    super("SetScreenPropertiesAction");
    this.screenWidth = screen.width;
    this.screenHeight = screen.height;
    this.screenInnerWidth = window.innerWidth;
    this.screenInnerHeight = window.innerHeight;
    this.sessionId = sessionId;
  }
};

export default SetScreenPropertiesAction;
